<template>
    <div id="group_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="groupHeader" v-if="$route.params.id > 0">Update Group</span>
                    <span class="page-title" id="groupHeader" v-else>Add Group</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackGroupList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content group-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="GroupForm">
                                <div class="form-row">
                                    <div class="col-sm-6 form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Group Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 form-group">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom"> Group Default 
                                                <input type="checkbox" v-model="checked" id="checked" name="checked" v-on:click="checkSelected($event)"> 
                                                <span class="checkmark"></span>
                                            </label>    
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createGroupBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateGroup" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createGroupBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateGroup" > 
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueGroupBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateGroup(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelGroupBtn" class="btn btn-tertiary" v-on:click.prevent="BackGroupList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins'


export default {
  name: "GroupList",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Group | " +process.env.COPYRIGHT_NAME : "Create Group | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    name: "",
    checkboxValue: "",
    checked: "",
    loading:false,
    name_error_msg: ""
  }),
  created: function() {

  },
  watch: {

      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_group') {
                      self.cantAccessPage = true;                  }
              }
          }

      }

   },
  mounted: function() {
        var self = this;
        self.checkboxValue = 0;

        // var path = window.location.pathname;
        // var segments = path.split("/");
        
        // if (segments[3]) {
        //     $("#createGroupBtn").val("Update");
        //     $("#groupHeader").text("Edit Group");
        //     $("#createAndContinueGroupBtn").hide();
        //     self.loadGroup();
            
        // }
        self.getPermissions();
        setTimeout(function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                
                if (segments[3]) {
                    self.loadGroup();
                }
            }, 100);
  },
  methods: {
    checkSelected: function(e) {
      var self = this;
      if (e.target.checked) {
      
        self.checkboxValue = 1;
      }else{
        self.checkboxValue = 0;
      }
    },
    // checkSelected() {
    //     var self = this;
    //     if (self.checked != true) {
    //         self.checkboxValue = 1;
    //     } else {
    //         self.checkboxValue = 0;
    //     }
    // },

    BackGroupList(){
        var self = this;
        self.$router.push("/group/list");
    },

    CreateGroup(flag) {
      var self = this;

      self.name = self.name.trim();
      
      self.name_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      } else{
        self.name_error_msg = "";
      }

      if (self.name_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createGroupBtn").val("Updating ...");
                $("#createGroupBtn").prop("disabled", true);
                $("#cancelGroupBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueGroupBtn").val("Saving ...");
                    $("#createGroupBtn").prop("disabled", true);
                    $("#createAndContinueGroupBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);

                }else{

                    $("#createGroupBtn").val("Saving ...");
                    $("#createGroupBtn").prop("disabled", true);
                    $("#createAndContinueGroupBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/group/create",
                type: "POST",
                data: {name: self.name, is_default: self.checkboxValue, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createGroupBtn").val("Update");
                        $("#createGroupBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueGroupBtn").val("Save and Continue");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createGroupBtn").val("Save");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#GroupForm").trigger("reset");
                            self.name ="";
                            self.checkboxValue = "";
                            self.checked = "";  

                        }else{
                            self.$router.push("/group/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createGroupBtn").val("Update");
                        $("#createGroupBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#GroupForm").trigger("reset");
                            

                            $("#createAndContinueGroupBtn").val("Save and Continue");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createGroupBtn").val("Save");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'group-create')
                }
            });
      }else{
            self.errorValidationFocus();
      }
    },

    loadGroup() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/group/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.checked = data.content.is_default;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'group-by-id-load')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/GroupCreate.vue